'use client';

import { PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial } from '@/tina/__generated__/types';
//@ts-expect-error mux sux
import MuxVideo from '@mux/mux-video-react';
import * as stylex from '@stylexjs/stylex';
import { useEffect, useRef } from 'react';
import { Button } from '../Buttons';
import { UiIcon } from '../svg/UiIcon';
import { VideoPreviewCard } from './VideoPreview';
interface VideoHandlerProps {
  data: PageSectionsContentSectionContentBlocksVideoTestimonialsTestimonial;
}
export function VideoHandler({
  data
}: VideoHandlerProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const playerRef = useRef<HTMLVideoElement>(null);
  const playButtonRef = useRef<HTMLButtonElement>(null);
  function closeDialog() {
    dialogRef?.current?.close();
  }
  function stopBubbleUp(e: MouseEvent) {
    e.stopPropagation();
  }
  function playVideo() {
    dialogRef.current?.showModal();
    playerRef.current?.play();
  }
  function previewClickHandler() {
    playButtonRef.current?.click();
  }
  useEffect(() => {
    const dialog = dialogRef?.current;
    const pause = () => {
      playerRef?.current?.pause();
    };
    dialogRef?.current?.addEventListener('close', pause);
    return () => dialog?.removeEventListener('close', pause);
  }, []);
  const PlayButton = <Button iconOnly={<UiIcon icon="Play" />} variant="media-action" size="regular" ref={playButtonRef} onClick={playVideo} controlled>
      Play Video
    </Button>;
  return <>
      <VideoPreviewCard data={data} playButton={PlayButton} onClick={previewClickHandler} />
      <dialog ref={dialogRef} className="xqirzj2 xnlluxf xng3xce xjbqb8w" data-lock-scroll onClick={closeDialog}>
        <div
      //@ts-expect-error unknown type spat as per
      onClick={stopBubbleUp} className="x11x033 x1n2onr6">
          <MuxVideo playbackId={data.video?.videoId} controls ref={playerRef} style={{
          width: '80vw'
        }} />
        </div>
      </dialog>
    </>;
}